import Reveal from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "Listen",
    body:
      "Every wall begins with a long conversation — with the place, the people, the smell of the street. We listen before we lift a brush.",
  },
  {
    n: "02",
    title: "Sketch",
    body:
      "We translate those conversations into compositions, moodboards, and hand-drawn sketches — sometimes for weeks — until the wall finds its face.",
  },
  {
    n: "03",
    title: "Paint",
    body:
      "On site, with weather, dust, ladders, and chai. Our artists work in rotating teams, often 10–14 hour days, until the wall tells its own story.",
  },
  {
    n: "04",
    title: "Live",
    body:
      "A mural is meant to age, fade, and be touched. We photograph, document, and return — but the wall belongs to its place, not to us.",
  },
];

export default function Process() {
  return (
    <section className="relative py-24 md:py-40 px-5 md:px-10 bg-[var(--bg)] overflow-hidden">
      <div className="relative max-w-7xl mx-auto">
        <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-3">
            <Reveal>
              <div className="text-[10px] uppercase tracking-[0.32em] text-[var(--clay)]">
                — Practice
              </div>
              <div className="mt-3 font-display text-5xl md:text-7xl text-[var(--bone)]">
                02
              </div>
            </Reveal>
          </div>
          <div className="col-span-12 md:col-span-9">
            <Reveal delay={120}>
              <h2 className="font-display font-light text-[clamp(2.5rem,5.5vw,5rem)] leading-[1.05] tracking-tight text-[var(--bone)]">
                How a wall becomes{" "}
                <span className="italic font-extralight">a mural.</span>
              </h2>
            </Reveal>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-px bg-[var(--line)] border-t border-b border-[var(--line)]">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 80}>
              <div className="group relative bg-[var(--bg)] p-8 md:p-12 h-full hover:bg-[var(--bg-soft)] transition-colors">
                <div className="flex items-start justify-between mb-6">
                  <div className="font-display text-3xl md:text-4xl text-[var(--clay-light)]">
                    {s.n}
                  </div>
                  <div className="w-10 h-10 grid place-items-center rounded-full border border-[var(--line)] text-[var(--bone)] group-hover:border-[var(--clay)] group-hover:text-[var(--clay)] transition-colors">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M7 17L17 7M9 7h8v8" />
                    </svg>
                  </div>
                </div>
                <h3 className="font-display text-3xl md:text-4xl text-[var(--bone)] mb-4">
                  {s.title}
                </h3>
                <p className="text-[var(--muted)] text-[15px] leading-relaxed max-w-md">
                  {s.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}